<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>体力不足弹窗</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            prop="count"
            label="弹窗次数"
            align="center"
          />
          <el-table-column
            prop="user"
            label="弹窗人数"
            align="center"
          />
          <el-table-column
            prop="pop_up_rate"
            label="弹出率"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="260"
                trigger="hover"
                content="弹出率=弹出人数/dau"
              >
                <span slot="reference">弹出率 <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">
              {{ scientificFormat(scope.row.pop_up_rate) }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="pop_up_avg"
            label="人均弹出次数"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="260"
                trigger="hover"
                content="人均弹出次数=弹出次数/弹出人数 "
              >
                <span slot="reference">人均弹出次数 <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">
              {{ scientificFormat(scope.row.pop_up_avg) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="order"
            label="购买人数"
            align="center"
          />
          <el-table-column
            prop="order_rate"
            label="购买率"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="260"
                trigger="hover"
                content="购买率=弹框人数/购买人数 "
              >
                <span slot="reference">购买率 <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">
              {{ scientificFormat(scope.row.order_rate) }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="play_order_rate"
            label="下单成功率"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="260"
                trigger="hover"
                content="下单成功率=下单成功/弹出次数 "
              >
                <span slot="reference">下单成功率 <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">
              {{ scientificFormat(scope.row.play_order_rate) }}%
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <shareCountStat ref="userStat" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <shareUserStat ref="shareUser" />
        </el-col>
      </el-row>
    </template>
  </BasicLayout>
</template>
<script>
import { getSpinPopUpStat } from '@/api/user/user_info'
import shareCountStat from '@/views/config/pay-stat/components/share-count-stat.vue'
import shareUserStat from '@/views/config/pay-stat/components/share-user-stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
export default {
  name: 'SpinPopUp',
  components: {
    shareCountStat,
    shareUserStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getSpinPopUpStat(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        this.tableData = res.data
        this.$refs.userStat.refresh(this.tableData)
        this.$refs.shareUser.refresh(this.tableData)
      })
    }
  }
}
</script>

<style scoped>
</style>
